import {
  alpha,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'

import type React from 'react'
import { useTranslation } from 'react-i18next'

interface ReorderConfirmModalProps {
  open: boolean
  onCancel: () => void
  onConfirm: () => void
}

export const ReorderConfirmModal: React.FC<ReorderConfirmModalProps> = ({
  open,
  onCancel,
  onConfirm,
}) => {
  const { t } = useTranslation()
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      PaperProps={{
        sx: {
          borderRadius: '12px',
          width: 368,
          padding: 1,
        },
      }}>
      <DialogTitle sx={{ fontSize: 15, fontWeight: 700, pb: 0.75 }}>
        {t('marketplace:reorderClearBasketTitle')}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.55 }}>
          {t('marketplace:reorderClearBasketBody')}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          variant="outlined"
          onClick={onCancel}
          sx={{
            borderRadius: '100px',
            textTransform: 'none',
            fontWeight: 600,
            color: 'text.secondary',
            borderColor: 'divider',
          }}>
          {t('marketplace:reorderCancel')}
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          sx={{
            borderRadius: '100px',
            textTransform: 'none',
            fontWeight: 600,
            boxShadow: (theme) => `0 2px 8px ${alpha(theme.palette.primary.main, 0.3)}`,
          }}>
          {t('marketplace:reorderConfirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
